var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoponto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6H4.5V4H20.5V6ZM14.8 12C14 12.96 13.5 14.18 13.5 15.5C13.5 16.64 13.93 17.86 14.5 19V20H4.5V14H3.5V12L4.5 7H20.5L21.2 10.5C20.54 10.18 19.82 10 19.06 10L18.86 9H6.14L5.54 12H14.8ZM12.5 14H6.5V18H12.5V14ZM22.5 15.5C22.5 18.1 19 22 19 22C19 22 15.5 18.1 15.5 15.5C15.5 13.6 17.1 12 19 12C20.9 12 22.5 13.6 22.5 15.5ZM20.2 15.6C20.2 15 19.6 14.4 19 14.4C18.4 14.4 17.8 14.9 17.8 15.6C17.8 16.2 18.3 16.8 19 16.8C19.7 16.8 20.3 16.2 20.2 15.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoponto);
export default __webpack_public_path__ + "static/media/Ecoponto.9fe05d0d6256c27d7bb75f1fa7f39743.svg";
export { ForwardRef as ReactComponent };